module.exports = __webpack_public_path__ + "static/media/image_news.0a4b42c8.png";